module.exports = __webpack_public_path__ + "img/sap.c6366900.png";